import initHeader from './modules/header';
import initHeroSlider from './modules/hero-slider';
import initTestimonials from './modules/testimonials';
import initOrbit from './modules/orbit';
import initReveal from './modules/reveal';
import initAmeliaPopup from './modules/amelia-popup';

document.documentElement.classList.remove('no-js');

initHeader();
initHeroSlider();
initTestimonials();
initOrbit();
initReveal();
initAmeliaPopup();
